export { default } from './SpecificationCollapse';
